<div class="perform-action-list ms-2 ms-lg-0">
    <div id="actionIndicator" class="position-relative z-index-vline"></div>
    <!-- the top arrow pointing down-->
    <button id="square-perform-action-top"
        class="btn bar-square square-perform-action text-white first-action-icon z-index-action" type="button"
        (click)="scrollToAction()">
        <i class="bi bi-arrow-down-short" aria-hidden="true"></i>
    </button>
    <!-- Actions (the numbered badges)-->
    <span *ngFor="let actor of userActors; let i = index"
        class="badge {{ actor.hasSigned ? 'bg-success' : currentActor.id == actor.id ? 'bg-primary' :'bg-subtle-primary' }} rounded-pill perform-action-list-item z-index-action mt-1"
        id="badge{{actor.badgeNumber}}">
        <span class="align-middle">{{actor.badgeNumber}}</span>
    </span>
    <div class="perform-action-bottom-element">
        <!-- the bottem arrow pointing Up-->
        <button id="square-perform-action-bottom" class="btn bar-square square-perform-action text-white z-index-action"
            type="button" (click)="scrollToAction()">
            <i class="bi bi-arrow-up-short" aria-hidden="true"></i>
        </button>
    </div>
</div>